import React, { FC, memo } from 'react'

import { useActiveBroadcast } from '@/hooks/useActiveBroadcast'
import { ChannelType } from '@/types/servicesTypes/configTypes'

import { ChannelItem } from './ChannelItem'
import { ChannelsListLoader } from './ChannelsListLoader'

const ChannelsListRaw: FC<{ broadcastId: string }> = ({ broadcastId }) => {
  const { channels } = useActiveBroadcast(broadcastId)

  return channels?.length ? (
    <>
      {channels.map((channel: ChannelType, i: number) => {
        return (
          <ChannelItem
            data={channel}
            id={channel.id}
            key={`${broadcastId}_${channel.id}_${i}`}
            broadcastId={broadcastId}
          />
        )
      })}
    </>
  ) : (
    <ChannelsListLoader />
  )
}

export const ChannelsList = memo(ChannelsListRaw)
